import api from './api';

// Normalize API response (snake_case) → frontend shape (camelCase)
const normalizeReview = (item) => ({
  id: item.id,
  clientName: item.client_name,
  clientPhoto: item.client_photo ?? null,
  rating: item.rating,
  reviewText: item.review_text,
  isApproved: Boolean(item.approved),
  createdAt: item.created_at,
  updatedAt: item.updated_at,
});

// Denormalize frontend shape (camelCase) → API payload (snake_case)
const denormalizeReview = (data) => ({
  ...(data.clientName  !== undefined && { client_name:  data.clientName }),
  ...(data.rating      !== undefined && { rating:       data.rating }),
  ...(data.reviewText  !== undefined && { review_text:  data.reviewText }),
  ...(data.isApproved  !== undefined && { approved:     data.isApproved }),
  ...(data.clientPhoto !== undefined && { client_photo: data.clientPhoto }),
});

export const reviewService = {
  // GET /api/reviews  — supports Laravel-style paginated response
  getAll: async (params = {}) => {
    const apiParams = {
      page:     params.page  || 1,
      per_page: params.limit || 10,
      ...(params.search ? { search: params.search } : {}),
      ...(params.status ? { status: params.status } : {}),
    };
    const response = await api.get('/reviews', { params: apiParams });
    // Support both { data: { data: [...], total, ... } } and flat { data: [...] }
    const pagination = response.data.data ?? response.data;
    const items = pagination.data ?? (Array.isArray(pagination) ? pagination : []);
    return {
      data: {
        reviews:    items.map(normalizeReview),
        total:      pagination.total      ?? items.length,
        page:       pagination.current_page ?? (params.page || 1),
        totalPages: pagination.last_page   ?? 1,
      }
    };
  },

  // GET /api/reviews/:id
  getById: async (id) => {
    const response = await api.get(`/reviews/${id}`);
    const item = response.data.data ?? response.data;
    return { data: normalizeReview(item) };
  },

  // POST /api/reviews
  create: async (data) => {
    const payload = denormalizeReview(data);
    const response = await api.post('/reviews', payload);
    const item = response.data.data ?? response.data;
    return { data: normalizeReview(item) };
  },

  // PUT /api/reviews/:id
  update: async (id, data) => {
    const payload = denormalizeReview(data);
    const response = await api.put(`/reviews/${id}`, payload);
    const item = response.data.data ?? response.data;
    return { data: normalizeReview(item) };
  },

  // DELETE /api/reviews/:id
  delete: async (id) => {
    return api.delete(`/reviews/${id}`);
  },

  // PATCH /api/reviews/:id/toggle-approval
  toggleApproval: async (id) => {
    const response = await api.patch(`/reviews/${id}/toggle-approval`);
    const item = response.data.data ?? response.data;
    return { data: normalizeReview(item) };
  },
};
